export function SliderCartPromoTile(promo) {
  const container = document.createElement('div');
  container.className = 'SliderCartPromoTile is-initial-select';
  container.style.backgroundImage = `url('${promo.background_img_url}')`;

  if (Array.isArray(promo.content_blocks)) {
    promo.content_blocks.forEach((block) => {
      if (block.type === 'text_block') {
        const textDiv = document.createElement('div');
        textDiv.className = 'SliderCartPromoTile__text_block';
        const settings = block.settings || {};

        textDiv.style.fontFamily = settings.font_family || '';
        textDiv.style.fontSize =
          typeof settings.font_size === 'number' ? `${settings.font_size}px` : settings.font_size || '';
        textDiv.style.fontWeight = settings.font_weight || '';
        textDiv.textContent = settings.text || '';

        container.appendChild(textDiv);
      } else {
        const hr = document.createElement('hr');
        container.appendChild(hr);
      }
    });
  }

  return container;
}
